/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';
import { controllable } from '@instructure/ui-prop-types';
const propTypes = {
  label: PropTypes.string.isRequired,
  language: PropTypes.oneOf(['sh', 'js', 'json', 'javascript', 'jsx', 'shell', 'css', 'html', 'markdown', 'yaml', 'yml', 'bash']),
  readOnly: PropTypes.bool,
  editable: PropTypes.bool,
  lineNumbers: PropTypes.bool,
  foldGutter: PropTypes.bool,
  highlightActiveLineGutter: PropTypes.bool,
  highlightActiveLine: PropTypes.bool,
  lineWrapping: PropTypes.bool,
  autofocus: PropTypes.bool,
  spellcheck: PropTypes.bool,
  direction: PropTypes.oneOf(['ltr', 'rtl']),
  rtlMoveVisually: PropTypes.bool,
  indentOnLoad: PropTypes.bool,
  indentWithTab: PropTypes.bool,
  indentUnit: PropTypes.string,
  defaultValue: PropTypes.string,
  value: controllable(PropTypes.string, 'onChange', 'defaultValue'),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  attachment: PropTypes.oneOf(['bottom', 'top']),
  height: PropTypes.string,
  width: PropTypes.string,
  // darkTheme: PropTypes.bool,
  elementRef: PropTypes.func,
  containerRef: PropTypes.func
};
const allowedProps = ['label', 'language', 'readOnly', 'editable', 'lineNumbers', 'foldGutter', 'highlightActiveLineGutter', 'highlightActiveLine', 'lineWrapping', 'autofocus', 'spellcheck', 'direction', 'rtlMoveVisually', 'indentOnLoad', 'indentWithTab', 'indentUnit', 'defaultValue', 'value', 'onChange', 'onFocus', 'onBlur', 'attachment', 'height', 'width',
// 'darkTheme',
'elementRef', 'containerRef'];
export { propTypes, allowedProps };